import { Environment } from '@classifieds-sell/environment';
import { defaultEnvironment } from './environment.default';

// noinspection JSUnusedGlobalSymbols
export const environment: Environment = {
    ...defaultEnvironment,
    apiBaseUrlForGringotts: 'https://api.test2h.trademe.co.nz/',
    authUrl: 'https://test.auth.trademe.co.nz/',
    name: 'test',
    production: false,
    trademeUrl: 'https://www.test2h.trademe.co.nz/',
    propertyMaintenanceMode: false
};
